export default () => jQuery(($) => {

	// auto-merge sections with the same name (allows multiple blocks on a page to append to existing sections)
	var sectionDivs = $('.facstaff-section-wrapper');
	var sectionLabelsFound = [];
	sectionDivs.each(function (idx, currentSection) {
		var currentAnchor = $(currentSection).find('.facStaffHead a').attr('name');
		var existingAnchor = sectionLabelsFound.find(function (elem) {
			return elem.anchor == currentAnchor;
		});

		if (existingAnchor) {
			var currentEntries = $(currentSection).find('.facStaff');
			var appendToWrapper = $('#' + existingAnchor.id);
			appendToWrapper.append(currentEntries);
			$(currentSection).remove();
		} else {
			sectionLabelsFound.push({
				anchor: currentAnchor,
				id: $(currentSection).attr('id')
			});
		}
	});
	// cycle the section divs again to remove whitespace and de-dupe people
	sectionDivs.each((idx, currentSection) => {
		var currentEntries = $(currentSection).find('.facStaff');
		var existingEntries = [];
		currentEntries.each((idx, currentEntry) => {
			var currentNetID = $(currentEntry).children('a').attr('name');

			if ($.inArray(currentNetID, existingEntries) !== -1) {
				$(currentEntry).remove();
			} else {
				existingEntries.push(currentNetID);
				$(currentSection).append(currentEntry);
			}
		});
	});

	// reset the section divs and cycle them to remove whitespace
	sectionDivs = $('.facstaff-section-wrapper');
	sectionDivs.each((idx, current) => {
		var currentEntries = $(current).find('.facStaff');
		$(current).append(currentEntries);
	});

	const wrapper = $('.facStaffBlock');

	wrapper.addClass('dynamic');
	const firstWrapper = (wrapper.hasClass('collapsed')) ? 'collapsed' : 'open';

	if (wrapper.hasClass('collapsed') || wrapper.hasClass('open')) {
		wrapper.addClass(firstWrapper);
	} else {
		wrapper.addClass('collapsed');
	}

	// Find the list of existing sections after possible merging
	let allSections = sectionLabelsFound.map(section => {
		return section.anchor;
	});
	if (allSections.length <= 2) {
		wrapper.children('.facStaffNavLinks').hide();
		wrapper.children('.facStaffHead').hide();
	} else {
		wrapper.children('.facStaffNavLinks').each(function (idx, current) {
			if (idx > 0) {
				$(current).remove();
			}
		});
	}

	// If a sort order is indicated on the page somewhere, use it to reorder the sections (uses the first one found)
	var sectionOrder = '';
	wrapper.each((idx, block) => {
		var sectionOrderFound = $(block).attr('data-sections-order');
		if (! sectionOrder && sectionOrderFound) {
			sectionOrder = sectionOrderFound;
		}
	});
	if (sectionOrder) {
		sectionOrder = sectionOrder.split(',').map(item => item.trim()).map(item => item.toLowerCase());
		// console.log('Section Order:', sectionOrder);
		var allSectionsSorted = [];
		var appendSections = [];
		sectionOrder.forEach((sortSection) => {
			var foundSection = allSections.find(section => section.toLowerCase() == sortSection);
			if (foundSection) {
				allSectionsSorted.push(foundSection);
			}
		});
		allSections.forEach((exisitingSection) => {
			var foundSection = allSectionsSorted.find(section => section == exisitingSection);
			if (!foundSection) {
				appendSections.push(exisitingSection);
			}
		});
		allSections = allSectionsSorted.concat(appendSections);
	}

	// re-draw the nav/jump-links in case there are merged sections and/or re-ordered sections
	const newJumpLinks = allSections.map(section => {
		return `<a href="#${section}" class="facStaffNavLink">${section}</a>`;
	}).join('<span class="divider"> | </span>');
	wrapper.children('.facStaffNavLinks').children('.facStaffNavLink').remove();
	wrapper.children('.facStaffNavLinks').prepend(newJumpLinks);

	// if we've resorted the section order, we need to rearrange the divs:
	// first we add items found in the order list, then we append anything left over
	if (sectionOrder) {
		var newDivOrder = [];
		allSections.forEach(section => {
			var foundDiv = sectionDivs.has(`.facStaffHead a[name="${section}"]`).has('.facStaff');
			newDivOrder.push(foundDiv);
		});
		sectionDivs.remove();
		wrapper.each((idx, block) => {
			if (idx > 0) {
				$(block).remove();
			}
		});
		newDivOrder.forEach(thisDiv => {
			wrapper.append(thisDiv);
		});
	}

	const facStaff = wrapper.find('.facstaff-section-wrapper .facStaff');
	const names = facStaff.children('.facStaffName');

	const nameSize = function () {
		if (wrapper.hasClass('collapsed')) {
			let largest = 0;
			names.css('height', 'auto').each(function (e) {
				const height = $(this).height();
				if (height > largest)
					largest = height;
				if ($(this).siblings('.facStaffImage, .facStaffImageReplacement').length < 1) {
					$(this).before('<div class="facStaffImageReplacement"></div>');
				}
			});
			names.css('height', largest + 'px');
		}
	};

	const doInfoWidth = function () {
		const blocks = facStaff.filter('.open');
		blocks.each(function () {
			$(this).children('.facStaffInfoWrapper').css('width', wrapper.width()).css('margin-left', $(this).position().left * -1);
		});
	};

	const facStaffExpandEnable = function () {
		facStaff.children('.facStaffImage, .facStaffImageReplacement, .facStaffName').click(function (e) {
			e.preventDefault();
			let state = 'closed';
			if ($(this).parent().hasClass('open')) {
				state = 'open';
			}
			facStaff.removeClass('open');
			if ('closed' === state) {
				const facStaffInfoWrapper = $(this).parent().children('.facStaffInfoWrapper');
				facStaffInfoWrapper.css('overflow', 'hidden').css('height', 0);
				$(this).parent().addClass('open');
				doInfoWidth();
				const itemHeight = facStaffInfoWrapper.children('.facStaffName').outerHeight() + facStaffInfoWrapper.children('.facStaffInfoWrapper2').outerHeight();
				const completion = function () {
					facStaffInfoWrapper.css('overflow', 'visible').css('height', 'auto');
				};
				// Use the itemHeight as the duration to ensure all open at same speed: 1ms/px
				facStaffInfoWrapper.animate({height: itemHeight}, itemHeight, 'linear', completion);
			}
		});
	};

	const expander = $('<a href="#" class="expander">List View</a>');
	const collapser = $('<a href="#" class="collapser">Grid View</a>');
	if (expander.length && collapser.length) {
		expander.click(function (e) {
			e.preventDefault();
			wrapper.removeClass('collapsed').addClass('open');
			names.css('height', 'auto');
			facStaff.find('.facStaffInfoWrapper').css('width', 'auto').css('margin-left', 0);
			// Remove click-to-expand in List View so profile and photo links work properly
			facStaff.find('.facStaffImage, .facStaffImageReplacement, .facStaffName').off('click');
		});
		collapser.click(function (e) {
			e.preventDefault();
			facStaff.removeClass('open');
			wrapper.addClass('collapsed').removeClass('open');
			nameSize();
			doInfoWidth();
			// Re-enable click-to-expand
			facStaffExpandEnable();
		});
		if (wrapper.children('.facStaffNavLinks').length > 0)
			wrapper.children('.facStaffNavLinks').first().append(expander).append(collapser);
		else if (wrapper.children('#deptInfo').length > 0)
			wrapper.children('#deptInfo').append(expander).append(collapser);
		else
			wrapper.prepend(expander).prepend(collapser);
		wrapper.find('.expander, .collapser').wrapAll('<span class="expandCollapse"></span>');
	}

	$(window).resize(doInfoWidth);
	facStaff.each(function () {
		$(this).children('.facStaffName').clone().prependTo($(this).children('.facStaffInfoWrapper'));
	});

	$(window).resize(nameSize);
	$(window).load(function () {
		nameSize();

		if (wrapper.hasClass('collapsed')) {
			facStaffExpandEnable();
		}
	});
});
